import React from "react";
import { FaArrowRight, FaEye, FaMap } from "react-icons/fa";
import digitalPreview from "../../assets/images/digital-twin-preview.png";
import virtualPreview from "../../assets/images/mobile-showcase/awesome-features-mockup.png";
import "../css/TwinDiscovery.css";

export default function TwinDiscovery({ onOpen }) {
  return (
    <section className="twin-discovery" id="twin-discovery" aria-labelledby="twin-discovery-title">
      <div className="twin-discovery-inner">
        <header className="twin-discovery-heading">
          <span>Understand the water. Explore the possibilities.</span>
          <h2 id="twin-discovery-title">Flood monitoring &amp; simulation</h2>
          <p>Two ways to understand flooding—see monitored conditions or explore a possible scenario.</p>
        </header>
        <div className="twin-discovery-grid">
          <article className="twin-discovery-card">
            <div className="twin-discovery-preview twin-discovery-preview--digital">
              <span className="twin-discovery-preview-label"><FaEye aria-hidden="true" /> Digital Twin</span>
              <img src={digitalPreview} width="321" height="729" loading="lazy" decoding="async" alt="Mobile preview of the Digital Twin showing a three-dimensional water-level model" />
              <span className="twin-discovery-preview-note">Water-level monitoring · Preview</span>
            </div>
            <div className="twin-discovery-copy">
              <span className="twin-discovery-eyebrow">Monitored conditions</span>
              <h3>See current water conditions.</h3>
              <p>View the latest monitored water levels, warning thresholds, and recent readings alongside a 3D view.</p>
              <ul aria-label="Digital Twin features"><li>Water levels</li><li>Warning thresholds</li><li>Recent history</li></ul>
              <button type="button" onClick={() => onOpen("digital-twin")}>Explore Digital Twin <FaArrowRight aria-hidden="true" /></button>
            </div>
          </article>
          <article className="twin-discovery-card">
            <div className="twin-discovery-preview twin-discovery-preview--virtual">
              <span className="twin-discovery-preview-label"><FaMap aria-hidden="true" /> Virtual Twin</span>
              <img src={virtualPreview} width="666" height="375" loading="lazy" decoding="async" alt="Mobile preview of the Virtual Twin showing the community flood simulation" />
              <span className="twin-discovery-preview-note">Flood scenario simulation · Preview</span>
            </div>
            <div className="twin-discovery-copy">
              <span className="twin-discovery-eyebrow">Simulated scenarios</span>
              <h3>Explore what rising water could mean.</h3>
              <p>Explore a flood simulation and see how rising water may affect households and surrounding areas.</p>
              <ul aria-label="Virtual Twin features"><li>Flood scenarios</li><li>Community view</li><li>Affected households</li></ul>
              <button type="button" onClick={() => onOpen("virtual-twin")}>Explore Virtual Twin <FaArrowRight aria-hidden="true" /></button>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
